import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Clock, Battery } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <Clock className="w-6 h-6 text-rose-500" data-id="element-201" />,
    title: 'La Hinchazón Vespertina',
    text: 'Te levantas bien, pero para las 2:00 PM tu pantalón aprieta y para las 6:00 PM pareces de 4 meses.'
  }, {
    icon: <AlertCircle className="w-6 h-6 text-rose-500" data-id="element-202" />,
    title: 'El Abdomen Rígido',
    text: "Haces abdominales y cardio, pero esa 'panza dura' no baja con nada. No es grasa, es inflamación."
  }, {
    icon: <Battery className="w-6 h-6 text-rose-500" data-id="element-203" />,
    title: 'Fatiga Crónica',
    text: "Te sientes cansada incluso después de dormir. Tu cuerpo está en modo 'supervivencia' constante."
  }];
  return <section id="problem" className="py-20 bg-white relative" data-id="element-204">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-205">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-206">
          <span className="text-sage-600 font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-207">
            Identidad
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-6" data-id="element-208">
            ¿Te suena familiar esta historia?
          </h2>
          <p className="text-lg text-charcoal-light leading-relaxed" data-id="element-209">
            "Te levantas, te miras al espejo y todo parece bien. Pero para las
            2:00 PM, tu pantalón empieza a apretar. Para las 6:00 PM, te sientes
            como si hubieras comido por tres."
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-210">
          {problems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-cream-100 p-8 rounded-2xl border border-beige-200 hover:shadow-lg transition-shadow" data-id="element-211">
              <div className="w-12 h-12 bg-rose-100 rounded-full flex items-center justify-center mb-6" data-id="element-212">
                {item.icon}
              </div>
              <h3 className="text-xl font-serif font-bold text-charcoal mb-3" data-id="element-213">
                {item.title}
              </h3>
              <p className="text-charcoal-light" data-id="element-214">{item.text}</p>
            </motion.div>)}
        </div>

        <div className="mt-16 max-w-4xl mx-auto bg-rose-50 rounded-3xl p-8 md:p-12 border border-rose-200" data-id="element-215">
          <h3 className="text-2xl font-serif font-bold text-charcoal mb-4 text-center" data-id="element-216">
            El problema no eres tú. Es un{' '}
            <span className="text-rose-600" data-id="element-217">Incendio Hormonal</span>.
          </h3>
          <p className="text-lg text-charcoal-light text-center leading-relaxed" data-id="element-218">
            Has probado el ayuno, has probado el cardio, has probado a dejar el
            azúcar. Y la respuesta siempre es la misma:{' '}
            <strong data-id="element-219">más frustración.</strong> Mientras tu cuerpo crea que estás
            en peligro (estrés), guardará esa inflamación como escudo.
          </p>
        </div>
      </div>
    </section>;
}